export { default as SerpLendingDelaySlot } from './SerpLendingDelaySlot';
